<template>
  <div class="flowEditBody">
    <div class="body">
      <div class="bodyLeft">
        <div class="Steps">
          <template v-if="showFlowImage === null">
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              流程图暂无
            </p>
          </template>
          <template v-else>
            <img style="width: 100%" :src="flowImage" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import flowService from "@/CommonDP/service/flow-service";
import { getFlowImage } from "@/CommonDP/utils";

export default {
  props: {
    // 流程编码， flowDefinitionId 两者不可同时为空
    flowKey: {
      type: String,
      default: "",
    },

    // 流程版本号。与 flowKey 两者不可同时为空
    flowDefinitionId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      flowImage: "",
      showFlowImage: "",
    };
  },

  methods: {
    // 接口：显示流程图
    async showImage() {
      if (!this.flowKey && !this.flowDefinitionId) {
        this.$error("flowKey 与 flowDefinitionId 必需指定一个");
        return false;
      }
      await this.getFlowAndShowImage();
    },

    // 接口：显示流程图。已废弃
    showView(flowDefinitionId, flowKey) {
      this.getFlowAndShowImage(flowDefinitionId, flowKey);
    },

    async getFlowAndShowImage(flowDefinitionId, flowKey) {
      const res = await flowService.queryFlowDef(null, flowDefinitionId || this.flowDefinitionId, flowKey || this.flowKey);
      this.showFlowImage = res.data.flowImage;
      this.flowImage = getFlowImage(res.data.flowImage.slice(7));
    },
  },
};
</script>
<style lang="scss" scoped>
.flowEditBody {
  width: 100%;
  height: 100%;
}
.body {
  display: flex;
  justify-content: flex-start;
  height: 100%;
  .bodyLeft {
    width: 100%;
    height: 100%;
    .oper {
      width: 100%;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      padding-right: 20px;
      box-sizing: border-box;
      border-bottom: 1px solid #e5e8f1;
    }
    .Steps {
      width: 100%;
      height: calc(100% - 40px);
    }
  }
  .bodyRight {
    width: 30%;
    border-left: 2px solid #e4e7ed;
    // height: 100%;
  }
}
.readOnly {
  /deep/.add-node-btn {
    visibility: hidden;
  }
  /deep/.showClose {
    display: none;
    i {
      visibility: hidden;
    }
  }
  /deep/.branch-box {
    margin-top: 0;
    .add-branch {
      display: none;
    }
  }
}
</style>
